<template>
  <el-form :model="form" label-width="95px" :disabled="mode === 'view'">
    <el-form-item label="数据来源">
      <el-select v-model="form.dataSource" placeholder="请选择" filterable @change="sourceChange">
        <el-option
          v-for="item in columnData"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
    </el-form-item>
    <!-- <el-form-item label="专题样式">
      <el-select
        v-model="config.component"
        placeholder="请选择"
        filterable
        @change="layoutChange(config)"
      >
        <el-option
          v-for="item in h5TopicType"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item> -->
    <el-form-item label="图片展示">
      <el-select v-model="form.imageFit" placeholder="请选择" filterable @change="selectChange">
        <el-option
          v-for="item in imageFitType"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <!-- <el-form-item label="展示行数">
      <el-input-number
        v-model="form.row"
        :min="1"
        @change="selectChange"
        controls-position="right"
        class="w-full"
      />
    </el-form-item> -->
    <el-form-item label="每行展示条数">
      <el-input-number
        v-model="form.col"
        :min="1"
        @change="selectChange"
        controls-position="right"
        class="w-full"
      />
    </el-form-item>
    <el-form-item label="展示条数">
      <el-input-number
        v-model="form.pageSize"
        :min="1"
        :max="20"
        @change="selectChange"
        controls-position="right"
        class="w-full"
      />
    </el-form-item>
    <el-form-item label="显示名称" v-if="form.showTitle">
      <el-input
        v-model="form.title"
        placeholder="显示名称"
        @input="selectChange"
        maxlength="20"
        clearable
      />
    </el-form-item>
    <el-form-item label="显示栏目名称">
      <el-checkbox v-model="form.showTitle" @change="selectChange"></el-checkbox>
    </el-form-item>
    <el-form-item label="显示更多">
      <el-checkbox v-model="form.showMore" @change="selectChange"></el-checkbox>
    </el-form-item>
    <layoutConfig
      :config="config"
      :layoutWidth="layoutWidth"
      :layout="layout"
      @layoutChange="layoutChange"
    />
  </el-form>
</template>

<script>
import { ColumApi } from '@wiz-api/workbench'
import { imageFitType } from '../../js/config'
import { h5TopicType } from '../../js/appConfig'
import layoutConfig from './LayoutConfig'

const columnApi = new ColumApi()
export default {
  props: ['configData', 'layoutData', 'mode', 'layoutWidth', 'layout'],
  components: {
    layoutConfig,
  },
  data() {
    return {
      form: {
        dataSource: '', // 数据来源
        pageSize: 1, // 展示条数
        row: 1, // 展示行数
        col: 1, // 每行展示条数
        imageFit: 'fill', // 图片展示方式
        showMore: true, // 显示更多
        title: '', // 显示名称
        showTitle: true, // 显示栏目名称
      },
      config: {
        component: h5TopicType[0].value,
        w: 10,
        h: 10,
      },
      columnData: [],
      h5TopicType,
      imageFitType,
    }
  },
  watch: {
    'form.pageSize': {
      handler(newV) {
        this.form.row = Math.floor(newV / this.form.col)
      },
    },
    configData: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!_.isEmpty(val)) {
          _.assign(this.form, val)
        } else {
          this.form = this.$options.data().form
          this.selectChange()
        }
      },
    },
    layoutData: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!_.isEmpty(val)) {
          this.config = _.pick(this.layoutData, ['w', 'h', 'component', 'type', 'x', 'y', 'i'])
        }
      },
    },
  },
  methods: {
    async getColumnData() {
      const [err, res] = await columnApi.tree(1)
      if (!err) {
        this.columnData = _.filter(res, (item) => {
          return item.type === this.config.type
        })
      }
    },
    sourceChange() {
      this.form.title = _.find(this.columnData, { id: this.form.dataSource }).name
      this.selectChange()
    },
    selectChange() {
      this.form.row = Math.floor(this.form.pageSize / this.form.col)
      this.$emit('configChange', this.form)
    },
    layoutChange(val) {
      this.config = _.cloneDeep(val)
      this.$emit('layoutChange', val)
    },
  },
  created() {
    this.getColumnData()
  },
}
</script>

<style></style>
